import { Directive, Input, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[detailHost]"
})
export class DetailHostDirective {
  @Input() rowId: string | number;

  constructor(public viewContainerRef: ViewContainerRef) {}
}